import fetchApp from 'actions/registry/fetch-app';
import fetchInstalledApps from 'actions/registry/fetch-installed-apps';
import fetchInstalledAppsStatus from 'actions/registry/fetch-installed-apps-status';
import fetchInstalledAppStatus from 'actions/registry/fetch-installed-app-status';
import setCurrentlySyncing from 'actions/gallery/set-currently-syncing';
import notifyAppInstallProgress from 'actions/gallery/notify-app-install-progress';
import triggerAppSync from 'actions/gallery/trigger-app-sync';

import InstallFlow from 'models/install-flow';

const defaultState = {};

const reduceInstallState = (state) => {
  const installFlow = InstallFlow.selectFromState(state);
  if (installFlow.isDifferent(state.installFlow)) {
    return {
      ...state,
      installFlow: installFlow.toState()
    };
  }

  return state;
};

export default (state = defaultState, { type }) => {
  switch (type) {
    case fetchApp.complete:
    case fetchInstalledApps.complete:
    case fetchInstalledAppsStatus.complete:
    case fetchInstalledAppStatus.complete:
    case setCurrentlySyncing.SET_CURRENTLY_SYNCING:
    case notifyAppInstallProgress.complete:
    case triggerAppSync.complete:
      return reduceInstallState(state);
    default:
      return state;
  }
};
